import { HttpClient } from '@angular/common/http';
import { ID } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { Form } from '@state/form';


@Injectable({ providedIn: 'root' })
export class FormsService {
  constructor(private http: HttpClient) {}

  getAvailableForms$(organization_id: ID): Observable<Form[]> {
    let url = `${environment.apiUrl}/v1/forms`;
    let params = { organization_id: organization_id as string };
    return this.http.get<Form[]>(url, { params });
  }

  getForm$(id: ID): Observable<Form> {
    let url = `${environment.apiUrl}/v1/forms/${id}`;
    return this.http.get<Form>(url);
  }

  importSections$({ form_id, section_ids }: { form_id: ID; section_ids: ID[] }): Observable<Form> {
    let url = `${environment.apiUrl}/v1/forms/${form_id}/import_sections`;
    return this.http.post<Form>(url, { section_ids });
  }
}
